import * as yup from "yup";

const CreateHeader = [
  { name: "nav_lists", label: "Nav Lists", type: "text" },
  { name: "agentId", label: "Agent ID", type: "text" },
  { name: "seoTitle", label: "SEO Title", type: "text" },
  { name: "seoDescription", label: "SEO Description", type: "text" },
  { name: "seoKeyword", label: "SEO Keyword", type: "text" },
];

const imageValidate = yup
  .mixed()
  .test("fileFormat", "Unsupported file format", (value) => {
    if (!value || !value[0]) return true;
    const file = value[0];
    if (file && file.name) {
      const fileExtension = file.name.split(".").pop().toLowerCase();
      const supportedFormats = [
        "jpeg",
        "jpg",
        "png",
        "gif",
        "bmp",
        "svg",
        "webp",
      ];
      return supportedFormats.includes(fileExtension);
    }
    return false;
  })
  .required("should not be empty");

const validationHeaderSchema = yup.object().shape({
  nav_left_logo: yup.object().shape({
    image: yup
      .mixed()
      .test("fileFormat", "Unsupported file format", (value) => {
        if (!value || !value.file) return true;
        const fileExtension = value.file.name.split(".").pop().toLowerCase();
        const supportedFormats = [
          "jpeg",
          "jpg",
          "png",
          "gif",
          "bmp",
          "svg",
          "webp",
        ];
        return supportedFormats.includes(fileExtension);
      })
      .nullable()
      .required("logo is required"),
    link: yup.string().url("Invalid URL format").required("link is required"),
    alt: yup.string().required("alt text is required"),
    target: yup.string().required("target is required"),
  }),
  nav_lists: yup
    .array()
    .of(
      yup.object().shape({
        text: yup.string().required("text is required"),
        link: yup
          .string()
          .url("Invalid URL format")
          .required("link is required"),
        target: yup.string(),
        order: yup.number().when("link", {
          then: yup.string().required("order is required when link is present"),
        }),
      })
    )
    .notRequired(),
  agent_id: yup.string().required("Agent ID is required"),
  seo_title: yup.string().required("SEO Title is required"),
  seo_description: yup.string().required("SEO Description is required"),
  seo_keywords: yup.string().required("SEO Keywords are required"),
  seoDone: yup.boolean(),
  share_image: yup.object().shape({
    image: yup
      .mixed()
      .test("fileFormat", "Unsupported file format", (value) => {
        if (!value || !value.file) return true;
        const fileExtension = value.file.name.split(".").pop().toLowerCase();
        const supportedFormats = [
          "jpeg",
          "jpg",
          "png",
          "gif",
          "bmp",
          "svg",
          "webp",
        ];
        return supportedFormats.includes(fileExtension);
      })
      .nullable()
      .required("logo is required"),
  }),
  share_title: yup.string().required("share title is required"),
  share_description: yup.string().required("share description is required"),
  favicon: yup.object().shape({
    image: yup
      .mixed()
      .test("fileFormat", "Unsupported file format", (value) => {
        if (!value || !value.file) return true;
        const fileExtension = value.file.name.split(".").pop().toLowerCase();
        const supportedFormats = [
          "jpeg",
          "jpg",
          "png",
          "gif",
          "bmp",
          "svg",
          "webp",
        ];
        return supportedFormats.includes(fileExtension);
      })
      .nullable()
      .required("logo is required"),
  }),
  created_by: yup.string(),
});

const CreateBody = [
  {
    name: "recharge_bill_payment_banner_mobile",
    label: "recharge bill payment",
    type: "text",
  },
  {
    name: "credit_card_offer_banner_mobile",
    label: "credit card offer",
    type: "text",
  },
  {
    name: "free_product_offer_banner_mobile",
    label: "free product offer",
    type: "text",
  },
  {
    name: "bill_payment_issue_banner_mobile",
    label: "bill payment issue",
    type: "text",
  },
  { name: "agent_id", label: "agent Id", type: "text" },
  {
    name: "bill_payment_service_logo_mobile",
    label: "bill payment service logo",
    type: "image",
  },
];

const validationBodySchema = yup.object().shape({
  recharge_bill_payment_banner_mobile: yup.array().of(
    yup.object().shape({
      image: yup
        .mixed()
        .test("fileFormat", "Unsupported file format", (value) => {
          if (!value || !value.file) return true;
          const fileExtension = value.file.name.split(".").pop().toLowerCase();
          const supportedFormats = [
            "jpeg",
            "jpg",
            "png",
            "gif",
            "bmp",
            "svg",
            "webp",
          ];
          return supportedFormats.includes(fileExtension);
        })
        .nullable()
        .required("logo is required"),
      link: yup.string().url("Invalid url format").required("link is required"),
      target: yup.string().required("target is required"),
      order: yup.number().required("order is required"),
      alt: yup.string().required("alt text is required"),
    })
  ),
  recharge_bill_payment_banner_desktop: yup.array().of(
    yup.object().shape({
      image: yup
        .mixed()
        .test("fileFormat", "Unsupported file format", (value) => {
          if (!value || !value.file) return true;
          const fileExtension = value.file.name.split(".").pop().toLowerCase();
          const supportedFormats = [
            "jpeg",
            "jpg",
            "png",
            "gif",
            "bmp",
            "svg",
            "webp",
          ];
          return supportedFormats.includes(fileExtension);
        })
        .nullable()
        .required("logo is required"),
      link: yup.string().url("Invalid url format").required("link is required"),
      target: yup.string().required("target is required"),
      order: yup.number().required("order is required"),
      alt: yup.string().required("alt text is required"),
    })
  ),
  free_product_offer_banner_mobile: yup.array().of(
    yup.object().shape({
      image: yup
        .mixed()
        .test("fileFormat", "Unsupported file format", (value) => {
          if (!value || !value.file) return true;
          const fileExtension = value.file.name.split(".").pop().toLowerCase();
          const supportedFormats = [
            "jpeg",
            "jpg",
            "png",
            "gif",
            "bmp",
            "svg",
            "webp",
          ];
          return supportedFormats.includes(fileExtension);
        })
        .nullable()
        .required("logo is required"),
      link: yup.string().url("Invalid url format").required("link is required"),
      target: yup.string().required("target is required"),
      order: yup.number().required("order is required"),
      alt: yup.string().required("alt text is required"),
    })
  ),
  credit_card_offer_banner_mobile: yup.array().of(
    yup.object().shape({
      image: yup
        .mixed()
        .test("fileFormat", "Unsupported file format", (value) => {
          if (!value || !value.file) return true;
          const fileExtension = value.file.name.split(".").pop().toLowerCase();
          const supportedFormats = [
            "jpeg",
            "jpg",
            "png",
            "gif",
            "bmp",
            "svg",
            "webp",
          ];
          return supportedFormats.includes(fileExtension);
        })
        .nullable()
        .required("logo is required"),
      link: yup.string().url("Invalid url format").required("link is required"),
      target: yup.string().required("target is required"),
      order: yup.number().required("order is required"),
      alt: yup.string().required("alt text is required"),
    })
  ),
  credit_card_loan_offer_banner_mobile: yup.array().of(
    yup.object().shape({
      image: yup
        .mixed()
        .test("fileFormat", "Unsupported file format", (value) => {
          if (!value || !value.file) return true;
          const fileExtension = value.file.name.split(".").pop().toLowerCase();
          const supportedFormats = [
            "jpeg",
            "jpg",
            "png",
            "gif",
            "bmp",
            "svg",
            "webp",
          ];
          return supportedFormats.includes(fileExtension);
        })
        .nullable()
        .required("logo is required"),
      link: yup.string().url("Invalid url format").required("link is required"),
      target: yup.string().required("target is required"),
      order: yup.number().required("order is required"),
      alt: yup.string().required("alt text is required"),
    })
  ),
  bill_payment_issue_banner_mobile: yup.array().of(
    yup.object().shape({
      image: yup
        .mixed()
        .test("fileFormat", "Unsupported file format", (value) => {
          if (!value || !value.file) return true;
          const fileExtension = value.file.name.split(".").pop().toLowerCase();
          const supportedFormats = [
            "jpeg",
            "jpg",
            "png",
            "gif",
            "bmp",
            "svg",
            "webp",
          ];
          return supportedFormats.includes(fileExtension);
        })
        .nullable()
        .required("logo is required"),
      link: yup.string().url("Invalid url format").required("link is required"),
      target: yup.string().required("target is required"),
      order: yup.number().required("order is required"),
      alt: yup.string().required("alt text is required"),
    })
  ),
  body_content_mobile: yup.array().of(
    yup.object().shape({
      logo: yup
        .mixed()
        .test("fileFormat", "Unsupported file format", (value) => {
          if (!value || !value.file) return true;
          const fileExtension = value.file.name.split(".").pop().toLowerCase();
          const supportedFormats = [
            "jpeg",
            "jpg",
            "png",
            "gif",
            "bmp",
            "svg",
            "webp",
          ];
          return supportedFormats.includes(fileExtension);
        })
        .nullable()
        .required("logo is required"),
      title: yup.string().required("title is required"),
      description: yup.string().required("description is required"),
    })
  ),
  agent_id: yup.string().required("Agent ID is required"),
  created_by: yup.string(),
  cash_voucher_heading: yup
    .string()
    .required("cash voucher heading is required"),
  cash_voucher_subHeading: yup
    .string()
    .required("cash voucher subheading is required"),
  disclaimer_heading: yup.string().required("disclaimer heading is required"),
  disclaimer: yup.string().required("disclaimer is required"),
  bill_payment_service_logo: yup.object().shape({
    image: yup
      .mixed()
      .test("fileFormat", "Unsupported file format", (value) => {
        if (!value || !value.file) return true;
        const fileExtension = value.file.name.split(".").pop().toLowerCase();
        const supportedFormats = [
          "jpeg",
          "jpg",
          "png",
          "gif",
          "bmp",
          "svg",
          "webp",
        ];
        return supportedFormats.includes(fileExtension);
      })
      .nullable()
      .required("logo is required"),
  }),
  recharge_bill_payment_heading: yup.string().required(),
});

const CreateFooter = [
  { name: "agentId", label: "agent Id", type: "text" },
  { name: "footer_images", label: "footer Images", type: "text" },
];

const commonItem = yup.array().of(
  yup.object().shape({
    text: yup.string(),
    link: yup.string().url("invalid url format").optional(),
    target: yup.string(),
    order: yup.number().notRequired(),
  })
);

const validationFooterSchema = yup.object().shape({
  customer_support: yup.array().of(
    yup.object().shape({
      text: yup.string().required("text is required"),
      value: yup.string().required("value is required"),
      order: yup.number().required("order is required"),
      link: yup
        .string()
        .test("is-valid-link", "Invalid link format", (value) => {
          if (!value) return true; // Allow empty link
          return value.startsWith("mailto:") || isValidURL(value);
        }),
    })
  ),
  brand_partners: commonItem,
  quick_links: commonItem,
  bank_partners: commonItem,
  social_media: yup.array().of(
    yup.object().shape({
      logo: yup
        .mixed()
        .test("fileFormat", "Unsupported file format", (value) => {
          if (!value || !value.file) return true;
          const fileExtension = value.file.name.split(".").pop().toLowerCase();
          const supportedFormats = [
            "jpeg",
            "jpg",
            "png",
            "gif",
            "bmp",
            "svg",
            "webp",
          ];
          return supportedFormats.includes(fileExtension);
        })
        .nullable()
        .required("logo is required"),
      link: yup.string().url("Invalid URL format").required("link is required"),
      target: yup.string(),
      alt: yup.string().required("should not be empty"),
      order: yup.number().required("order is required"),
    })
  ),
  agent_id: yup.string().required("agent Id is required"),
  copy_right: yup.string(),
  footer_logo: yup.object().shape({
    logo: yup
      .mixed()
      .test("fileFormat", "Unsupported file format", (value) => {
        if (!value || !value.file) return true;
        const fileExtension = value.file.name.split(".").pop().toLowerCase();
        const supportedFormats = [
          "jpeg",
          "jpg",
          "png",
          "gif",
          "bmp",
          "svg",
          "webp",
        ];
        return supportedFormats.includes(fileExtension);
      })
      .nullable()
      .required("logo is required"),
    link: yup.string().required("link is required"),
  }),
  footer_images: yup.array().of(
    yup.object().shape({
      image: yup
        .mixed()
        .test("fileFormat", "Unsupported file format", (value) => {
          if (!value || !value.file) return true;
          const fileExtension = value.file.name.split(".").pop().toLowerCase();
          const supportedFormats = [
            "jpeg",
            "jpg",
            "png",
            "gif",
            "bmp",
            "svg",
            "webp",
          ];
          return supportedFormats.includes(fileExtension);
        })
        .nullable()
        .required("image is required"),
      link: yup.string().url("Invalid URL format"),
      target: yup.string().when("link", {
        // is: (link) => !!link, // If link is present (not null or undefined)
        then: yup.string().required("Target is required when link is present"),
        // otherwise: yup.string().notRequired(),
      }),
      alt: yup.string().required("should not be empty"),
      order: yup.number().required("order is required"),
    })
  ),
});

const validationAgentCreationSchema = yup.object().shape({
  name: yup.string().required("agent name is required"),
  eligible_payment_mode: yup.array().min(1, "must have atleast 1 item"),
  active_payment_mode: yup.string().required("active payment mode is required"),
  url: yup.string().required("url is required"),
});

const validationAssignCampaignSchema = yup.object().shape({
  ai_id: yup.string().required("agent is required"),
  campaign_id: yup.string().required("campaign is required"),
});

function isValidURL(url) {
  try {
    new URL(url);
    return true;
  } catch (error) {
    return false;
  }
}

export {
  validationFooterSchema,
  CreateFooter,
  validationBodySchema,
  CreateBody,
  validationHeaderSchema,
  CreateHeader,
  validationAgentCreationSchema,
  validationAssignCampaignSchema,
};
